import * as config from '../../lib/config';
import Auth from '../../auth/auth';

import {
  CLEAR_TENANT,
  FETCH_TENANT_BY_ID_START,
  FETCH_TENANT_BY_ID_SUCCESS,
  FETCH_TENANT_BY_ID_FAILURE,
} from '../tenant/types';

import {
  ADD_PROJECT_TO_TENANT_START,
  ADD_PROJECT_TO_TENANT_SUCCESS,
  ADD_PROJECT_TO_TENANT_FAILURE,
  RESTORE_PROJECT_START,
  RESTORE_PROJECT_SUCCESS,
  RESTORE_PROJECT_FAILURE,
  DEACTIVATE_PROJECT_START,
  DEACTIVATE_PROJECT_SUCCESS,
  DEACTIVATE_PROJECT_FAILURE,
  DELETE_PROJECT_START,
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_FAILURE,
  FETCH_PROJECTS_SUCCESS,
} from './types';

import { toast } from 'react-toastify';

// Actions
const clearTenant = () => ({
  type: CLEAR_TENANT,
});

const fetchTenantByIdStart = () => ({
  type: FETCH_TENANT_BY_ID_START,
});

const fetchTenantByIdSuccess = (tenant) => ({
  type: FETCH_TENANT_BY_ID_SUCCESS,
  payload: tenant,
});

const fetchTenantByIdFailure = (error) => ({
  type: FETCH_TENANT_BY_ID_FAILURE,
  payload: error,
});

const addProjectToTenantStart = () => ({
  type: ADD_PROJECT_TO_TENANT_START,
});

const addProjectToTenantSuccess = (res) => ({
  type: ADD_PROJECT_TO_TENANT_SUCCESS,
  payload: res,
});

const addProjectToTenantFailure = (error) => ({
  type: ADD_PROJECT_TO_TENANT_FAILURE,
  payload: error,
});

const deactivateProjectStart = () => ({
  type: DEACTIVATE_PROJECT_START,
});

const deactivateProjectSuccess = (res) => ({
  type: DEACTIVATE_PROJECT_SUCCESS,
  payload: res,
});

const restoreProjectStart = () => ({
  type: RESTORE_PROJECT_START,
});

const restoreProjectSuccess = (res) => ({
  type: RESTORE_PROJECT_SUCCESS,
  payload: res,
});

const restoreProjectFailure = (error) => ({
  type: RESTORE_PROJECT_FAILURE,
  payload: error,
});

const deactivateProjectFailure = (error) => ({
  type: DEACTIVATE_PROJECT_FAILURE,
  payload: error,
});

const deleteProjectStart = () => ({
  type: DELETE_PROJECT_START,
});
const deleteProjectSuccess = (res) => ({
  type: DELETE_PROJECT_SUCCESS,
  payload: res,
});
const deleteProjectFailure = (error) => ({
  type: DELETE_PROJECT_FAILURE,
  payload: error,
});
// End actions //

// Error handlers //
function handleFetchErrors(response) {
  if (!response.ok) {
    throw Error('Failed to retrieve tenants.');
  }
  return response;
}

function handleAddProjectError(res, toastId) {
  if (!res.ok) {
    if (toastId) {
      toast.update(toastId, {
        render: 'Failed to add user to tenant',
        type: toast.TYPE.ERROR,
        autoClose: 3000,
      });
    }
    throw Error('Failed to add user.');
  }
  return res;
}

function handleDeactivateProjectError(res, toastId) {
  if (!res.ok) {
    if (toastId) {
      toast.update(toastId, {
        render: 'Failed to deactivate project',
        type: toast.TYPE.ERROR,
        autoClose: 3000,
      });
    }
    throw Error('Failed to deactivate project:', res);
  }
  return res;
}

function handleRestoreProjectError(res, toastId) {
  if (!res.ok) {
    if (toastId) {
      toast.update(toastId, {
        render: 'Failed to restore project',
        type: toast.TYPE.ERROR,
        autoClose: 3000,
      });
    }
    throw Error('Failed to restore project:', res);
  }
  return res;
}

function handleDeleteProjectError(res, toastId) {
  if (!res.ok) {
    if (toastId) {
      toast.update(toastId, {
        render: 'Failed to delete project',
        type: toast.TYPE.ERROR,
        autoClose: 3000,
      });
    }
    throw Error('Failed to delete project:', res);
  }
  return res;
}
// End error handlers //

// API actions //
export const fetchTenantById = (id, updateToast) => (dispatch) => {
  dispatch(fetchTenantByIdStart());
  new Auth().checkAuth();
  return fetch(`${config.baseURL()}/api/tenants/${id}`, {
    method: 'get',
    credentials: 'include',
  })
    .then(handleFetchErrors)
    .then((res) => res.json())
    .then((json) => {
      dispatch(fetchTenantByIdSuccess(json));
      if (updateToast) {
        toast.update(updateToast.toastId, {
          render: updateToast.message,
          type: toast.TYPE[updateToast.type],
          autoClose: 3000,
        });
      }
    })
    .catch((error) => {
      dispatch(fetchTenantByIdFailure(error));
    });
};

export const addProjectToTenant = (id, name) => (dispatch) => {
  let toastId = null;
  let toastNotify = () =>
    (toastId = toast('Adding new project...', { autoClose: false }));
  toastNotify();

  dispatch(addProjectToTenantStart());
  new Auth().checkAuth();
  return fetch(`${config.baseURL()}/api/tenants/${id}/projects`, {
    method: 'post',
    credentials: 'include',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(name),
  })
    .then((res) => handleAddProjectError(res, toastId))
    .then((res) => {
      let updateToast = {
        toastId,
        type: 'SUCCESS',
        message: 'Project added to tenant',
      };
      dispatch(addProjectToTenantSuccess(res));
      dispatch(fetchProjects(id, updateToast));
    })
    .catch((error) => {
      dispatch(addProjectToTenantFailure(error));
    });
};

export const deactivateProject =
  (tenantId, projectId, active) => (dispatch) => {
    let toastId = null;
    let toastNotify = () =>
      (toastId = toast('Deactivating Project...', { autoClose: false }));
    toastNotify();

    dispatch(deactivateProjectStart());

    return fetch(
      `${config.baseURL()}/api/tenants/${tenantId}/projects/${projectId}`,
      {
        method: 'PATCH',
        credentials: 'include',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify(active),
      },
    )
      .then((res) => handleDeactivateProjectError(res, toastId))
      .then((res) => {
        let updateToast = {
          toastId,
          type: 'SUCCESS',
          message: 'Project deactivated',
        };
        dispatch(deactivateProjectSuccess(res));
        dispatch(fetchProjects(tenantId, updateToast));
      })
      .catch((error) => {
        dispatch(deactivateProjectFailure(error));
      });
  };

export const restoreProject = (tenantId, projectId, active) => (dispatch) => {
  let toastId = null;
  let toastNotify = () =>
    (toastId = toast('Restoring Project...', { autoClose: false }));
  toastNotify();

  dispatch(restoreProjectStart());
  return fetch(
    `${config.baseURL()}/api/tenants/${tenantId}/projects/${projectId}`,
    {
      method: 'PATCH',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(active),
    },
  )
    .then((res) => handleRestoreProjectError(res, toastId))
    .then((res) => {
      let updateToast = {
        toastId,
        type: 'SUCCESS',
        message: 'Project restored',
      };
      dispatch(restoreProjectSuccess(res));
      dispatch(fetchProjects(tenantId, updateToast));
    })
    .catch((error) => {
      dispatch(restoreProjectFailure(error));
    });
};

export const deleteProject = (command) => (dispatch) => {
  let toastId = null;
  let toastNotify = () =>
    (toastId = toast('Deleting Project...', { autoClose: false }));
  toastNotify();

  dispatch(deleteProjectStart());
  new Auth().checkAuth();
  return fetch(`${config.baseURL()}/api/commands`, {
    method: 'POST',
    credentials: 'include',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(command),
  })
    .then((res) => handleDeleteProjectError(res, toastId))
    .then((res) => {
      let updateToast = {
        toastId,
        type: 'SUCCESS',
        message: 'Project deleted',
      };
      dispatch(deleteProjectSuccess(res));
      dispatch(fetchProjects(command.tenantId, updateToast));
    })
    .catch((error) => {
      dispatch(deleteProjectFailure(error));
    });
};

export const clearTenantProp = () => (dispatch) => {
  dispatch(clearTenant());
};

export const copyProjectToTenant = (cmd, sourceTenantId) => (dispatch) => {
  const commandLabel = {
    start: 'Copying project to tenant',
    success: 'Project copied to tenant',
    fail: 'Failed to copy project to tenant',
  };
  let toastId = null;
  let toastNotify = () =>
    (toastId = toast(`${commandLabel.start || 'Sending command'}...`, {
      autoClose: false,
    }));
  toastNotify();
  if (sourceTenantId === cmd.tenantId) {
    dispatch({ type: 'MODIFY_TENANT_START' });
  }

  new Auth().checkAuth();
  return fetch(`${config.baseURL()}/api/commands`, {
    method: 'POST',
    credentials: 'include',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(cmd),
  })
    .then((res) => {
      if (sourceTenantId === cmd.tenantId) {
        dispatch(fetchProjects(cmd.tenantId, undefined));
        dispatch({ type: 'MODIFY_TENANT_COMPLETE' });
      }
      toast.update(toastId, {
        render: commandLabel.success || 'Sent',
        type: toast.TYPE.SUCCESS,
        autoClose: 3000,
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

export const fetchProjects = (tenantId, updateToast) => (dispatch) => {
  new Auth().checkAuth();
  return fetch(`${config.baseURL()}/api/tenants/${tenantId}/projects`, {
    method: 'get',
    credentials: 'include',
  })
    .then(handleFetchErrors)
    .then((res) => res.json())
    .then((json) => {
      dispatch({
        type: FETCH_PROJECTS_SUCCESS,
        payload: { tenantId: tenantId, projects: json },
      });
      if (updateToast) {
        toast.update(updateToast.toastId, {
          render: updateToast.message,
          type: toast.TYPE[updateToast.type],
          autoClose: 3000,
        });
      }
    })
    .catch((error) => {
      console.log('Error fetching projects:' + error);
    });
};
